import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé, nous vous répondons rapidement.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <section className="hero-bg py-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Nous contacter</div>
          <h1 className="font-heading text-4xl text-primary-blue mt-3">Une question ? Notre équipe vous répond.</h1>
          <p className="mt-3 text-slate-700">Réponse sous 24 h ouvrées. E-mail direct : <a className="text-primary-blue underline" href="mailto:contact@auditionexpert.com">contact@auditionexpert.com</a></p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-14">
        <form onSubmit={submit} className="bg-white p-8 rounded-2xl border border-slate-100 card-lux space-y-5" data-testid="contact-form">
          <div>
            <Label>Nom complet</Label>
            <Input value={form.name} onChange={(e) => set("name", e.target.value)} required className="mt-1 h-11" data-testid="contact-name" />
          </div>
          <div>
            <Label>E-mail</Label>
            <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required className="mt-1 h-11" data-testid="contact-email" />
          </div>
          <div>
            <Label>Sujet</Label>
            <Input value={form.subject} onChange={(e) => set("subject", e.target.value)} required className="mt-1 h-11" data-testid="contact-subject" />
          </div>
          <div>
            <Label>Message</Label>
            <Textarea rows={6} value={form.message} onChange={(e) => set("message", e.target.value)} required className="mt-1" data-testid="contact-message" />
          </div>
          <Button type="submit" disabled={sending} className="bg-primary-blue text-white" data-testid="contact-submit">
            {sending ? "Envoi…" : "Envoyer"}
          </Button>
        </form>
      </section>
    </div>
  );
}
